import { AlmeUIMessage } from '@alme/ui-web/types/response';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../../settings/alight-custom-settings';
import * as actions from '../actions/actions';

export default class ResponseHandler {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>) {
        this._store = store;
    }

    getReducer() {
        return (state = {}) => { return state; }
    }

    doesHandle(message: AlmeUIMessage) {
        return message.messageType === this._settings.messageConstants.extensibleRequest && message.messageSource === this._settings.initializationData.messageSourceName;
    }

    process(message: AlmeUIMessage) {
        if (!this.doesHandle(message)) return message;
        let initDataRetrieved = JSON.parse((message.response as any).initDataRetrieved);
        let stateLocation = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.initializationData.Base}.${this._settings.stateLocations.Window.initializationData.initDataRetrieved}`;
        this._store?.dispatch(actions.saveInitDataFlag({ stateLocation, initDataRetrieved }));

        let advocacyData = initDataRetrieved.advocacyConfigData;
        if(advocacyData != undefined && advocacyData != null)
        {
            let advocacyStateLocation = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.advocacyVariables.Base}.${this._settings.stateLocations.Window.advocacyVariables.advocacyConfigData}`;

            this._store?.dispatch(actions.saveUserAdvocacy(advocacyStateLocation, advocacyData))
        }

        //@ts-ignore
        let completedLocation = `${this._settings.stateLocations.Window.Base}.${this._settings.stateLocations.Window.initializationData.Base}.${this._settings.stateLocations.Window.initializationData.initializeCompleted}`

        this._store?.dispatch(actions.setUserInfoInitializeComplete(completedLocation));

        return message;
    }

}



// WEBPACK FOOTER //
// ./modules/initialization-data-handler/message-handlers/response.ts